import NotFound from 'common/NotFound';
import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { BiSolidOffer } from 'react-icons/bi';
import { CgBlock, CgUnblock } from 'react-icons/cg';
import { FaEdit, FaRegTrashAlt } from 'react-icons/fa';
import { RiCoupon3Line } from 'react-icons/ri';
import Pagination from 'react-js-pagination';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { offerListApi } from 'services/offer';
import { formatValidTillDate } from 'utils/common';
import findSerialNumber from 'utils/findSerialNumber';
import ReadMore from 'utils/readMoreModal/ReadMore';
import ChangeStatusOffer from './section/ChangeStatusOffer';
import DeleteOffer from './section/DeleteOffer';

const OfferList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const [offerList, setOfferList] = useState([]);
  const activePage = +searchParams.get("page") || 1;
  const [total, setTotal] = useState(0)
  const [blockData, setBlockData] = useState({ modal: false })
  const [deleteData, setDeleteData] = useState({ modal: false })
  const [readMoreData, setReadMoreData] = useState({ modal: false })
  const navigate = useNavigate()
  //------------Handel-Pagination------------
  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  // ----------handle-block-----------
  const handleBlock = (data) => {
    setBlockData({ ...data, modal: true })
  }
  // ----------handle-delete-----------
  const handleDelete = (data) => {
    setDeleteData({ ...data, modal: true })
  }
  const fetchPromoCodeList = async () => {
    const query = {
      page: activePage,
    };
    onShow();
    try {
      const res = await offerListApi(query);
      const { code, data } = res?.data;
      if (code === 200) {
        setTotal(data?.total || 0)
        setOfferList(data?.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchPromoCodeList();
  }, [activePage]);
  // -----------read-more-modal-------------
  const handleReadMore = (data) => {
    console.log("data", data)
    setReadMoreData({ description: data, modal: true, title: 'Message' })
     
  }
  useEffect(() => {
    // if (!search) {
    //   searchParams.delete("search");
    // }
    if (activePage === 1) {
      searchParams.delete("page");
    }
    setSearchParams(searchParams);
  }, [activePage]);
  return (
    <div className="user-management-container">
      <div className="page_title has_child">
        <h3>Offer Management</h3>
        <div className="tabContainer">
          <Link to='/offer-management/add'>
            <button
              className="button"
              type="button"
            >
              Add Offer
            </button>
          </Link>
        </div>
      </div>
      {/* ---------card */}
      <div className="card">
        {loader}
        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Title</th>
                <th className="nowrap text-center">Category</th>
                <th className="nowrap text-center">Details</th>
                <th className="nowrap text-center">Valid till</th>
                <th className="nowrap text-center">Type</th>
                <th className="nowrap text-center">Value</th>
                <th className="nowrap text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {offerList.length > 0 ? (
                offerList?.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, 10)}
                      </td>
                          <td className="nowrap text-center">
                        {data?.title
                          ? data.title.length > 15
                            ? (
                              <>
                                {data.title.slice(0, 15)}...
                                <button
                                  type="button"
                                  onClick={() => handleReadMore(data.title)}
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    marginLeft: 4,
                                    textDecoration: "underline",
                                    font: "inherit",
                                  }}
                                >
                                  Read More
                                </button>
                              </>
                            )
                            : data.description
                          : "N/A"
                        }
                      </td>
                      <td className="nowrap text-center">
                        {data?.category?.name || "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        {data.description.length > 15
                          ? <>
                            {data.description.slice(0, 15)}...
                            <span
                              onClick={() => handleReadMore(data.description)}
                              style={{ color: "blue", cursor: "pointer" }}
                            >
                              Read More
                            </span>
                          </>
                          : data.description || "N/A"
                        }
                      </td>

                      <td className="nowrap text-center">
                        {formatValidTillDate(data?.startDate, data?.endDate)}
                      </td>
                      <td className="nowrap text-center">
                        {data?.discountType || "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        {data?.discountValue || "N/A"}
                      </td>

                      <td className="nowrap text-center">
                        <div className="button-container">

                          <button
                            type="button"
                            onClick={() => {
                              navigate(`/offer-management/update/${data?._id}`)
                            }}
                          >
                            <FaEdit />
                          </button>
                          <button
                            type="button"
                            onClick={() => handleBlock(data)}
                            disabled={data?.status === "DELETED"}
                          >
                            {data?.status === "INACTIVE" ? (
                              <CgBlock style={{ color: "red" }} />
                            ) : (
                              <CgUnblock />
                            )}
                          </button>

                          <button
                            type="button"
                            onClick={() => handleDelete(data)}
                          >
                            <FaRegTrashAlt />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={7}
                  msg={"Promocode not found"}
                  onHide={onHide}
                  icon={<BiSolidOffer />}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* ---------change-status------------------- */}
      <ChangeStatusOffer
        show={blockData?.modal}
        close={() => setBlockData((prev) => ({ ...prev, modal: false }))}
        listing={fetchPromoCodeList}
        selectedData={blockData}
        offerList={offerList}
        setOfferList={setOfferList}
      />
      {/* ---------delete-------------------- */}
      <DeleteOffer
        modal={deleteData?.modal}
        close={() => setDeleteData((prev) => ({ ...prev, modal: false }))}
        selectedData={deleteData}
        setState={setOfferList}
      />
      {/* ---------read-more------------------- */}
      <ReadMore
        show={readMoreData?.modal}
        close={() => setReadMoreData({ ...readMoreData, modal: false })}
        title={readMoreData?.title}
        description={readMoreData?.description}
      />
      {/* ------pagination */}

      {total > 10 && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={10}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default OfferList